module.exports = __webpack_public_path__ + "media/images/sns-noimage-411d6664f29ac6adf76ac8ca0e6085b4.png";